import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { Product, AddToCartEvent } from '../../../../shared/models/product.model';
import { ProductCarouselComponent } from '../product-carousel/product-carousel.component';

export interface TopSellersBlockData {
  limit?: number;
  products: Product[];
}

@Component({
  selector: 'app-top-sellers-block',
  imports: [ProductCarouselComponent],
  templateUrl: './top-sellers-block.component.html',
  styleUrl: './top-sellers-block.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopSellersBlockComponent {
  // Espejo de `OffersBlockComponent`: render dumb del bloque `best-sellers`.
  readonly data = input<TopSellersBlockData | null>(null);

  protected readonly products = computed(() => this.data()?.products ?? []);
  protected readonly shouldRender = computed(() => this.products().length > 0);

  addToCart = output<AddToCartEvent>();
  zoomOpen = output<Product>();
  notifyRequest = output<Product>();
  notifyCancel = output<Product>();
  cardClick = output<Product>();
  reserveClick = output<Product>();
}
